import { ON_MESSAGE_READ, ON_MESSAGE_READING } from '../actions/types';

const INITIAL_STATE = { messages: [], loading: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_MESSAGE_READING:
      return { ...state, loading: true };
    case ON_MESSAGE_READ:
      return { ...state, messages: action.payload, loading: false };
    default:
      return state;
  }
};
